"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Pen = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Pen_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.698.407a1.425 1.425 0 0 0-1.203-.394c-.389.052-.731.244-.983.496L1.68 10.34a3.276 3.276 0 0 0-.803 1.295l-.799 2.47c-.145.446-.112 1.046.329 1.488.44.44 1.041.473 1.488.328l2.47-.8c.486-.157.932-.44 1.295-.802l9.831-9.832c.252-.252.444-.594.496-.983a1.425 1.425 0 0 0-.393-1.203L13.698.407Zm-1.072.598c.145-.02.277.02.365.109l1.895 1.895c.09.089.128.22.11.365a.725.725 0 0 1-.212.407l-2.648 2.648-2.565-2.565 2.648-2.648a.725.725 0 0 1 .408-.211ZM8.864 4.57l-6.477 6.477c-.259.258-.453.57-.558.896l-.8 2.469c-.059.184-.027.361.085.473.112.112.29.144.473.085l2.47-.8c.325-.105.637-.3.895-.558l6.477-6.477-2.565-2.565Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Pen_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Pen;
exports["default"] = _default;